import React from 'react'

const NotFound = () => {
  return (
    <div>
      <h1 className='text-center text-brand'>
        404 error!!
        <br />
        Page not found
      </h1>
    </div>
  )
}

export default NotFound
